import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';


const AuthRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/admin');

    // Check if user is authenticated
    if (token) {
        // Redirect unauthenticated users to login
        if (role == '1') {
            // If not an admin, redirect to the login page or another appropriate route
            return <Navigate to="/admin/group-offers" replace />;
        }
        return <Navigate to="/profile" replace />;
    }

    // If all checks pass, render the children (unprotected routes)
    return <Outlet />;
};

export default AuthRoute;
